import { useDialog } from '@dni-hooks/useDialog'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'

export const DIALOG_KEY = 'DialogConfirmDiscardAll'

export interface DialogConfirmDiscardAllProps {
  onConfirm?: () => void
}

export const DialogConfirmDiscardAll = (props: DialogConfirmDiscardAllProps) => {
  const { onConfirm } = props
  const { open, closeDialog } = useDialog(DIALOG_KEY)

  const handleConfirm = () => {
    closeDialog()
    onConfirm?.()
  }

  return (
    <Dialog
      disablePortal
      onClose={closeDialog}
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '320px',
          },
        },
      }}
    >
      <DialogTitle>
        <Text align="center" variant="h4" color={colors.grey900}>全部捨棄</Text>
      </DialogTitle>
      <DialogContent sx={{ height: 94 }}>
        <Text variant="body">將會清空購物車品項，並無法復原，請謹慎操作。</Text>
      </DialogContent>
      <DialogActions sx={{ gap: 1 }}>
        <Button fullWidth variant="outlined" onClick={closeDialog}>取消</Button>
        <Button fullWidth onClick={handleConfirm}>確認清空</Button>
      </DialogActions>
    </Dialog>
  )
}
